import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export type VenueCategory = { slug: string; name_ar: string; name_en: string; order: number; venues_count?: number };

let cache: VenueCategory[] | null = null;
let pending: Promise<VenueCategory[]> | null = null;
const listeners = new Set<(c: VenueCategory[]) => void>();

export const reloadVenueCategories = () => {
  pending = api.get("/venue-categories").then((r) => {
    cache = r.data;
    listeners.forEach((l) => l(r.data));
    return r.data;
  }).finally(() => { pending = null; });
  return pending;
};

export const useVenueCategories = () => {
  const [cats, setCats] = useState<VenueCategory[]>(cache || []);
  useEffect(() => {
    listeners.add(setCats);
    if (!cache && !pending) reloadVenueCategories();
    return () => { listeners.delete(setCats); };
  }, []);
  return cats;
};

export const catName = (cats: VenueCategory[], slug: string, lang: string) => {
  const c = cats.find((x) => x.slug === slug);
  return c ? (lang === "ar" ? c.name_ar : c.name_en) : "";
};
